/** Presentation and authoring state are independent of campaign identity. */
export function encounterSurfaceBootstrap(): {
    presentation?: string; canManageCampaign?: boolean; source?: string; sceneReviewFixture?: unknown;
    surface?: { canEditScene?: boolean; canRunTable?: boolean; queryOnly?: boolean; embedded?: boolean };
} | null {
    const raw = document.getElementById('modify_encounter_creation_engine_bootstrap')?.textContent;
    try { return raw ? JSON.parse(raw) : null; } catch { return null; }
}

export function encounterAuthoringActive(): boolean {
    if (document.body.classList.contains('ft3d-surface-leaving-edit')) return false;
    const shell = document.querySelector<HTMLElement>('[data-ft-encounter-surface]');
    if (shell) return shell.dataset.canEdit === 'true' && document.body.classList.contains('ft3d-surface-editing');
    const boot = encounterSurfaceBootstrap();
    if (!boot || boot.sceneReviewFixture || boot.source === 'query-review-fixture' || boot.surface?.queryOnly) return false;
    if (boot.surface && boot.surface.canEditScene !== true) return false;
    return boot.canManageCampaign === true && (boot.presentation !== 'ft3d-campaign-view'
        || document.body.classList.contains('ft3d-campaign-edit-mode-active'));
}

export function encounterPreviewSurface(): boolean {
    return !!document.querySelector('[data-ft-encounter-surface]')
        || encounterSurfaceBootstrap()?.surface?.canRunTable === false;
}
